import PropTypes from 'prop-types';
import React from 'react';
import styles from './dataSourceView.module.scss';
import cx from 'classnames';
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import DataSourceDeleteContainer from './DataSourceDeleteContainer';
import DataSourceMigrateView from "./DataSourceMigrateView";
import { localizedStrings } from 'src/localization/index.jsx';
import dateformat from 'dateformat';
import Truncate from 'src/components/truncate';
import _ from 'lodash';
import Tooltip from 'src/components/tooltip';

class DataSourceRow extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  };

  constructor(props){
    super(props);

    this.state = {
      showDeleteConfirmation: false,
      showMigrateConfirmation:false
    }

    this._handleSyncClick = this._handleSyncClick.bind(this);
    this._handledeleteClick = this._handledeleteClick.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;
  }

  _handleSyncClick() {
      this.props.syncSource({id: this.props.id})
  }

  _handledeleteClick() {
    this.setState({
      showDeleteConfirmation: true
    });
  }

  _handleMigrateClick(migrationStatus) {
    if(migrationStatus == "AUTH_ERROR" ){
      this.props.handleSourceAuthenticate()
    } else {
      this.setState({
        showMigrateConfirmation: true
      })
    }
    
  }

  render() {
    let imageStyle = this.props.storageType;
    let migrationStatus = this.props.migrationStatus;

    return(

      <div className={cx(styles.contentSourceContainer, {
        [styles.warningBackground] : migrationStatus === "AUTH_ERROR"
      })}>
        <div className={styles.innerContainer}>
          <i className={cx(styles.sourceImage, styles[imageStyle])} />
          {this.props.id != 0 &&
            <i onClick={() => this._handledeleteClick()} className={cx('paperflite-delete', styles.deleteIcon)} />
          }

          <div className={styles.contentContainer}>
            <div className={cx(styles.container, {
              [styles.animateContainer]: _.get(this.props, "lastMigrationDate", false)
            })}>
              <span className={styles.title}><Truncate lines={1} width={150} >{this.props.name || 'Unknown'}</Truncate></span>
              <div className={styles.subText}>{`${this.props.assets} ${this.localizedKeywords.assets}`} <span className={styles.seperator} /> {this.props.updateDate}</div>
            </div>
          </div>
          {this.props.lastMigrationDate &&
            <span className={styles.migrationDate}>{`${this.localizedContentSources.last_migrate_on} ${dateformat(this.props.lastMigrationDate, 'dd mmm yyyy')}`}</span>
          }
           
          {this.props.id != 0 && this.props.storageType != "rss" &&
            <div onClick={() => this._handleMigrateClick(migrationStatus)} className={cx(styles.actionIcons, styles.migrateIcon, { [styles.disabled]: migrationStatus == "MIGRATION_REQUESTED" }) }>
              {migrationStatus == "AUTH_ERROR" ?
              <span>
                  <Tooltip content={this.localizedContentSources.error_message} position="top" >
                  <i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
                  </Tooltip>
                <span className={styles.reauthenticate}>{this.localizedContentSources.reauthenticate}</span>
                </span>
                : migrationStatus == "MIGRATION_REQUESTED" ?
                <span className={styles.migrationIcon}>{this.localizedContentSources.migrating}...</span> : this.localizedContentSources.migrate}
            </div>
          }
        </div>

        <SlidePaneView width="28vw" show={this.state.showDeleteConfirmation || this.state.showMigrateConfirmation}>
           {this.state.showDeleteConfirmation && <DataSourceDeleteContainer name={this.props.name}
            store={this.context.store}
            assets={this.props.assets}
            onDelete={
              () => {
                this.setState({
                  deleting: true,
                  showDeleteConfirmation: false
                })
                this.props.deleteSource({id: this.props.id})
              }
            }
            onCancel={
              () => {
                this.setState({
                  showDeleteConfirmation: false
                });
              }
            }
          />}
          {
            this.state.showMigrateConfirmation &&  <DataSourceMigrateView name={this.props.name}
            store={this.context.store}
            assets={this.props.assets}
            onMigrate={
              () => {
                console.log('migrate contents..')
                this.setState({
                  showMigrateConfirmation: false
                })
                this.props.migrateDataSource({id: this.props.id});
              }
            }
            onCancel={
              () => {
                this.setState({
                  showMigrateConfirmation: false
                });
              }
            }
          />
          }
        </SlidePaneView>
      </div>
    );
  }   
}

export default DataSourceRow;
 
